/**
 * Create Reviews context for custom hook
 */
import { createContext } from 'react'

const ReviewsContext = createContext({
  fetchReviewsByProductID: () => {},
  createReview: () => {}
})

export default ReviewsContext
